var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form',_vm._b({staticClass:"cg-form",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return ((e) => _vm.$emit('submit', e)).apply(null, arguments)}}},'form',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }